module.exports = __webpack_public_path__ + "img/医疗配套_image.c183cd65.png";